<template>
    <div class="">
        <div class="ysc-box">
            <img src="img/centrum/ysc/img-centrum-doc.jpg" class="ysc-box-img" />
            <div class="btn-close" @click="closeMoreInfo">返回</div>
            <div class="ysc-box-txt">内审号PM-CN-CNT-25-00454  有效期至2030年9月21日</div>
        </div>
    </div>
</template>

<script setup>
import { eventBus } from "@/utils/eventBus"
const closeMoreInfo = () => {
    console.log('closeMoreInfo')
    eventBus.emit('closeMoreInfo', 'reset')
}
</script>

<style scoped>
.ysc-box {
    width: 100vw;
    /* background-image: url('/img/centrum/ysc/img-centrum-doc.jpg') ;
    background-size: cover;
    background-repeat: no-repeat; */
    pointer-events: auto;
    overflow-y: scroll;
    position: relative;
    height: calc(100vw * 2.1875);
}

.ysc-box-img {
    width: 100vw;
    position: absolute;
    z-index: 0;
    left: 0;
    top: 0;
    height: calc(100vw * 2.1875);
}

.btn-close {
    position: absolute;
    bottom: 10vh;
    left: calc((100% - 44vw) / 2);
    z-index: 2;
    width: 44vw;
    height: 12vw;
    pointer-events: auto;
    color: #1B1244;
    font-size: 18px;
    font-weight: bold;
    background-image: url('/img/btn-centrum-ysc.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 6vw;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ysc-box-txt {
    position: absolute;
    bottom: 14px;
    left: 10px;
    font-size: 12px;
    color: #fff;
}
</style>